module.exports = __webpack_public_path__ + "static/img/m3m2i1.a8a08fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/m3m2i1.png
// module id = 8Yr+
// module chunks = 1